import styled from 'styled-components'
import { FlexView, Card, Button } from '../../../../components/common'
import AppIcon from 'app-components/common/AppIcon'

export const FlexWrap = styled(FlexView)`
    flex-wrap: wrap;
`
export const IconButton = styled(Button)`  
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
    line-height: 27px;
    text-align: justify;
    display: flex;
    justify-content: center;
`
export const Subtitle = styled.h3`
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 20px;
    text-align: justify;
    color: #777777;
    margin: 16px 0;
`
export const DocPlaceholderImage = styled(AppIcon)`
    align-self: center;
    margin: 15px 0;
`
export const DocPlaceholder = styled(Card)`
    cursor: pointer;
    max-width: 180px;
    margin: 8px 16px;
    overflow: hidden;
    transition: transform .2s ease-in-out;

    &:hover {
        transform: scale(1.05);
     }  
    & .lastModification {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 14px;
        margin: 0;
    }

    & .docName {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        margin: 8px 0;
        text-overflow: ellipsis;
        word-break: break-all;
    }

`